import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
import "./PremiumVendors.css";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

const PremiumVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(
          `${BackEnd_URL}/api/v1/VendorManagement/show-AllVendorService`
        );

        if (
          response.data &&
          Array.isArray(response.data.data.allVendorService)
        ) {
          const parsedData = response.data.data.allVendorService.map(
            (vendor) => ({
              ...vendor,
              SpecialBadges: vendor.SpecialBadges
                ? JSON.parse(vendor.SpecialBadges)
                : [],
            })
          );
          setVendors(parsedData);
        } else {
          setVendors([]);
        }
      } catch (error) {
        console.error("Error fetching vendor services:", error);
        setVendors([]);
      }
    };

    fetchVendors();
  }, []);

  const parseImageUrl = (imageData) => {
    try {
      const parsedData = JSON.parse(imageData);
      const imagePath = parsedData[0]?.path.replace(/\\/g, "/");
      return (
        `${BackEnd_URL}/BannerUploads/${imagePath.split("/").pop()}` ||
        "/assets/dummyProfile.jpg"
      );
    } catch {
      return "/assets/dummyProfile.jpg";
    }
  };

  const HandleBack = () => {
    navigate("/admin-dashboard");
  };

  const filteredVendors = vendors.filter(
    (vendor) =>
      vendor.Vendor?.firstName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      vendor.ServiceName.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="premium-vendors-container">
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>

      {/* Heading */}
      <h2 className="heading">Premium Vendors</h2>

      {/* Search Field */}
      <div className="searchField">
        <input
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search vendors..."
          className="searchInput"
        />
      </div>

      {/* Vendor Cards */}
      <div className="vendor-cards-grid">
        {filteredVendors.length > 0 ? (
          filteredVendors.map((vendor) => (
            <div key={vendor.id} className="card vendor-card">
              <img
                src={
                  vendor.BannerImage
                    ? parseImageUrl(vendor.BannerImage)
                    : "/assets/dummyProfile.jpg"
                }
                className="card-img-top vendor-card-img"
                alt={vendor.ServiceName}
              />
              <div className="vendor-card-body">
                <h5 className="vendor-name">{vendor.Vendor?.firstName}</h5>
                <h4 className="vendor-name">{vendor.ServiceName}</h4>
                <div className="vendor-card-info">
                  <span>{vendor.City || "Unknown Location"}</span>
                  <br />
                  <span>Budget: {vendor.TotalBudget || "N/A"}</span>
                </div>
                {vendor.SpecialBadges.length > 0 && (
                  <div className="special-badges">
                    {vendor.SpecialBadges.map((badge, index) => (
                      <span key={index} className="badge">
                        {badge}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>No premium vendors available.</p>
        )}
      </div>
    </div>
  );
};

export default PremiumVendors;
